import { create } from "zustand"

interface LoadingState {
  isLoading: boolean
  targetRoute: string | undefined
  setLoading: (loading: boolean, targetRoute?: string) => void
}

export const useLoadingStore = create<LoadingState>((set) => ({
  isLoading: false,
  targetRoute: undefined,
  setLoading: (loading, targetRoute = undefined) => set({ isLoading: loading, targetRoute }),
}))
